import { Controller } from "@hotwired/stimulus";
import "./component.scss";

// @süle hier musst du nochmal drüberschauen irgendwie werden die Tags nciht richtig wieder abgewählt und man kann es noch nicht mit der tastatur machen.
export default class extends Controller {}
